// src/data/dealerServices.js

const DEALER_SERVICES = [
    "Supports NFA Transfers",
    "Offers Fingerprinting",
    "Appointments Available",
    "Accepts Credit Cards",
    "Used Firearms Accepted",
    "Consignment Sales"
];

export default DEALER_SERVICES;